import { useEffect, useState } from 'react'

import Transaction from '../components/Transaction';
import { useTheme, Box, Grid, Typography } from '@mui/material';
import { tokens } from '../theme';
import TopBar from '../components/TopBar';
import { useAuth } from '../components/AuthProvider';

import { fetchTransactions } from '../utils/apiHelpers';

function Transactions() {
	const [transactions, setTransactions] = useState([])
	const [loading, setLoading] = useState(true)

	const { user } = useAuth();

	useEffect(() => {
		if (user !== null) {
			fetchTransactions(user.admin === 1, user.id)
				.then(data => {
					setTransactions(data.sort((a, b) => new Date(b.date) - new Date(a.date)))
					setLoading(false);
				})
				.catch(err => console.log(err));
		}
	}, [])

	const theme = useTheme();
	const colors = tokens(theme.palette.mode);

	console.log(transactions)

	let index = 0;

	return (
	<div>
		<TopBar/>
		<Box sx={{borderBottom: 1, borderColor: colors.gray[500]}}>
			<Grid container display="flex" justifyContent="flex-start" sx={{m: "5px 0 5px 60px"}}>
				<Grid size={4}>
					<Typography variant="h4" color={colors.ceriseAccent[100]} fontWeight="medium" sx={{m : "0 0 0 10px" }}>
						Användare
					</Typography>
				</Grid>
				<Grid size={4}>
					<Typography variant="h4" color={colors.ceriseAccent[100]} fontWeight="medium" sx={{m : "0 0 0 10px" }}>
						Vara
					</Typography>
				</Grid>
				<Grid size={4}>
					<Typography variant="h4" color={colors.ceriseAccent[100]} fontWeight="medium" sx={{m : "0 0 0 10px" }}>
						Pris
					</Typography>
				</Grid>
			</Grid>
		</Box>
		<Box display="flex" flexDirection="column">
			{
				loading ? null :
				transactions.map((transaction) => {
					index++;
					return <Transaction transaction={transaction} index={index} colors={colors}/>
				})
			}
		</Box>
	</div>
	)
}

export default Transactions